import {
	send
} from '@/handlers';
import {
	erc20Abi,
	vantTokenAbi
} from '@/contracts';

import {
	Contract,
	BigNumber,
	ethers,
	BrowserProvider
} from 'ethers'

export default class Token {
	constructor(address = '', signer = null) {
		this.internalAddress = address; // TODO .toLowerCase();
		this.signer = signer;
		if (!this.address.match(/0x[a-fA-F0-9]{40}/)) return new Error('Missing token address');
		this.instance = new Contract(address, erc20Abi, signer);
	}

	get address() {
		return this.internalAddress;
	}

	getName() {
		return new Promise((resolve, reject) => {
			this.instance.name()
				.then(resolve)
				.catch(reject);
		});
	}

	get Symbol() {
		return new Promise((resolve, reject) => {
			this.instance.symbol()
				.then(resolve)
				.catch(reject);
		});
	}

	getDecimals() {
		return new Promise((resolve, reject) => {
			this.instance.decimals()
				.then((decimals) => Number(decimals))
				.then(resolve)
				.catch(reject);
		});
	}

	/**
	 * Returns the balance available of this token by the caller.
	 * @param {string=} from if specified executes the transaction using this account.
	 * @return {Promise<TXResult>}
	 */
	getBalanceOf(from = '') {
		return new Promise((resolve, reject) => {
			this.instance.balanceOf(from)
				.then((balance) => Number(balance))
				.then(resolve)
				.catch(reject);
		});
	}

	approve(to, amount, from = '') {
		return new Promise((resolve, reject) => {
			let parsedAmount;
			this.getDecimals().then((decimals) => {
					parsedAmount = ethers.parseUnits(amount.toString(), decimals);
					return this.instance.approve.estimateGas(to, parsedAmount)
				}).then((gas) => {
					return this.instance.approve(to, parsedAmount,{
						gasLimit: gas
					})
				}).then(resolve)
				.catch(reject);
		});
	}

	allowance(to, from = '') {
		return new Promise((resolve, reject) => {
			this.instance.allowance(from, to)
				.then(resolve)
				.catch(reject);
		});
	}

	transfer(to, amount, from = '') {
		return new Promise(async (resolve, reject) => {
			if (!from) {
				from = await this.signer.getAddress();
			}
			let parsedAmount;
			Promise.all([this.getBalanceOf(from), this.getDecimals()])
				.then(([balance, decimals]) => {
					parsedAmount = ethers.parseUnits(amount.toString(), decimals);
					console.log(balance, decimals,parsedAmount)
					if (balance < parsedAmount) {
						return reject("餘額不足");
					}
					return this.instance.transfer.estimateGas(to, parsedAmount)
				})
				.then((gas) => {
					return this.instance.transfer(to, parsedAmount, {
						gasLimit: gas
					});
				}).then(resolve).catch(reject);
		});
	}
}